import Proxy from './Proxy';

class CompanyProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/settings/company', parameters);
  }

  /**
   * 광고주리스트
   * @param isUserCompany : 사용자계정이 있는 회사만 검색
   * @returns {Promise}
   */
  findAdvertiserAll() {
    return this.submit('get', `${this.endpoint}/advertisers`);
  }

  /**
   * 계약서 다운로드 여부 설정
   * @param companySeq
   * @param download
   * @returns {Promise}
   */
  updateContractDownload(companySeq, download) {
    return this.submit('put', `/${this.endpoint}/${companySeq}/contract-download/${download}`);
  }

}

export default CompanyProxy;
